import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-homeseven-banner',
    templateUrl: './homeseven-banner.component.html',
    styleUrls: ['./homeseven-banner.component.scss']
})
export class HomesevenBannerComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {}

    trustedBySlides: OwlOptions = {
		nav: false,
		loop: true,
		margin: 25,
		dots: false,
		autoplay: true,
		autoplayHoverPause: true,
		navText: [
			"<i class='ri-arrow-left-s-line'></i>",
			"<i class='ri-arrow-right-s-line'></i>",
		],
		responsive: {
			0: {
				items: 3
			},
			576: {
				items: 4
			},
			768: {
				items: 4
			},
			992: {
				items: 4
			},
			1200: {
				items: 4
			}
		}
    }

}